export default {
	"No active account found with the given credentials": "帳號或密碼不正確"
};
